import { useEffect, useState } from "react";
import { getPaymentMethods } from "../../api/invoiceService";

export const usePaymentMethods = (trigger, emptyCallback) => {
  const [paymentMethods, setPaymentMethods] = useState({});
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPaymentMethods()
            .then((paymentMethods) => {
                setPaymentMethods(paymentMethods);
                if (emptyCallback && paymentMethods.length === 0) {
                    emptyCallback(true);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch payment methods:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [trigger]);

  return { paymentMethods, loading, setPaymentMethods };
};
